import React from 'react';
import { 
  HelpCircle, 
  Car, 
  Home, 
  AlertCircle, 
  FileText, 
  Calendar, 
  Landmark
} from 'lucide-react';

/**
 * Компонент информационной панели о налоге на роскошь
 */
const TaxInfoSidebar = () => {
  const taxInfo = [
    {
      icon: Car,
      title: 'Транспортный налог',
      description: 'Рассчитывается исходя из мощности двигателя (в л.с.) и повышающего коэффициента для дорогих автомобилей.'
    },
    {
      icon: Landmark,
      title: 'Налог на недвижимость',
      description: 'Для жилых помещений с кадастровой стоимостью более 300 млн ₽ ставка составляет 2%.'
    },
    {
      icon: Calendar,
      title: 'Сроки уплаты',
      description: 'Налоги уплачиваются не позднее 1 декабря года, следующего за налоговым периодом.'
    },
    {
      icon: FileText,
      title: 'Список роскошных авто',
      description: 'Минпромторг ежегодно публикует перечень автомобилей стоимостью от 3 млн ₽.'
    },
    {
      icon: AlertCircle,
      title: 'Налоговые льготы',
      description: 'Ветераны, инвалиды, пенсионеры и др. категории могут иметь право на льготы.'
    }
  ];

  return (
    <div className="bg-white dark:bg-gray-800 rounded-xl border border-gray-200 dark:border-gray-700 p-5 shadow-sm">
      <h3 className="text-lg font-medium text-gray-900 dark:text-white mb-4 flex items-center">
        <HelpCircle className="w-5 h-5 mr-2 text-indigo-500" />
        О налоге на роскошь
      </h3>

      <div className="space-y-3">
        {taxInfo.map((info, index) => (
          <div 
            key={index} 
            className="flex items-start space-x-3 p-3 bg-gray-50 dark:bg-gray-700/30 rounded-lg border border-gray-200 dark:border-gray-700 hover:bg-gray-100 dark:hover:bg-gray-700 transition-colors"
          >
            <info.icon className="w-5 h-5 text-indigo-500 mt-1 flex-shrink-0" />
            <div>
              <h4 className="text-sm font-medium text-gray-900 dark:text-white mb-1">
                {info.title}
              </h4>
              <p className="text-xs text-gray-600 dark:text-gray-400">
                {info.description}
              </p>
            </div>
          </div>
        ))}
      </div>

      <div className="mt-6 p-4 bg-indigo-50 dark:bg-indigo-900/20 border border-indigo-100 dark:border-indigo-800 rounded-lg">
        <div className="flex items-start space-x-3">
          <AlertCircle className="w-5 h-5 text-indigo-500 mt-1 flex-shrink-0" />
          <div>
            <h4 className="text-sm font-semibold text-indigo-700 dark:text-indigo-300 mb-2">
              Важные изменения в 2024 году
            </h4>
            <p className="text-xs text-indigo-600 dark:text-indigo-400 mb-3">
              В ряде регионов введены дополнительные льготы для электромобилей и семей с детьми.
            </p>
            <button className="w-full py-1.5 text-xs bg-indigo-500 text-white rounded hover:bg-indigo-600 transition-colors">
              Смотреть все изменения
            </button>
          </div>
        </div>
      </div>
    </div>
  );
};

export default TaxInfoSidebar;